import InputNumber from './inputNumber'
export { InputNumberProps } from './inputNumber'
export default InputNumber
